import { createContext, useContext, useState, useCallback, useMemo } from "react";
import translations from "./translations";

const LanguageContext = createContext();

const STORAGE_KEY = "mixordia-lang";


const interpolate = (str, vars) => {
  if (!vars || typeof str !== "string") return str;
  return Object.entries(vars).reduce(
    (acc, [key, val]) => acc.replace(new RegExp(`\\{\\{${key}\\}\\}`, "g"), val),
    str
  );
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY) || "pt";
      document.documentElement.lang = saved;
      return saved;
    } catch {
      return "pt";
    }
  });

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    document.documentElement.lang = newLang;
    try {
      localStorage.setItem(STORAGE_KEY, newLang);
    } catch {

    }
  }, []);

  const toggleLang = useCallback(() => {
    setLang(lang === "pt" ? "en" : "pt");
  }, [lang, setLang]);



  const t = useCallback(
    (key, vars) => {
      const dict = translations[lang] || translations.pt;


      if (vars?.count !== undefined) {
        const pluralKey = vars.count === 1 ? `${key}_one` : `${key}_other`;
        const pluralStr = dict[pluralKey];
        if (pluralStr) return interpolate(pluralStr, vars);
      }

      const str = dict[key];
      if (!str) {

        const fallback = translations.pt[key] || key;
        return interpolate(fallback, vars);
      }
      return interpolate(str, vars);
    },
    [lang]
  );

  const value = useMemo(
    () => ({ lang, setLang, toggleLang, t }),
    [lang, setLang, toggleLang, t]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};


export const useTranslation = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useTranslation must be used within LanguageProvider");
  return ctx;
};
